import { render, staticRenderFns } from "./TvSeries.vue?vue&type=template&id=43372503&scoped=true&"
import script from "./TvSeries.vue?vue&type=script&lang=js&"
export * from "./TvSeries.vue?vue&type=script&lang=js&"
import style0 from "./TvSeries.vue?vue&type=style&index=0&id=43372503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43372503",
  null
  
)

export default component.exports